export const basicToken = (userName, pass) => {
  const username = userName ?? "liberin@gmail.com";
  const password = pass ?? "liberin";
  const token = btoa(`${username}:${password}`);
  return token;
};
